import React from 'react'
import Picture from '../../components/Picture'


export default function () {
    return (
        <div className="container home-two-col sales-automation">
            <div className="column purple-col">
                <div className='col-texts'>
                    <h2 className="title">Automação de vendas </h2>
                    <h3 className="description">Organização e produtividade para sua equipe comercial com <b>sistema online e aplicativo</b></h3>
                </div>
                <Picture
                    className='desktop-only purple-col-img-mobile'
                    src="/images/site/new-home/pedidos-android.png"
                    alt='Automação de vendas - pedidos App'
                />
                <Picture
                    className='purple-col-img'
                    src="/images/site/new-home/pedidos-web.png"
                    alt='Automação de vendas - pedidos'
                    mobileSrc="/images/site/new-home/pedidos-web-mobile.png"
                />


            </div>
            <div className="column">
                <div className="checklist">
                    <div className="checklist-item">
                        <div className="checkmark checkmark-green"> </div>
                        <p><b>Aplicativo de vendas</b>: pedidos em poucos cliques mesmo sem internet com app super fácil de usar em Android e iOS. <a className="link-green" href="/aplicativo-vendas/">Clique aqui para saber mais.</a></p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark checkmark-green"></div>
                        <p><b>Pedidos sem erros</b>: políticas comerciais, promoções e tabelas de preços atualizadas e vinculadas a cada cliente.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark checkmark-green"> </div>
                        <p><b>Aumente suas vendas</b>: indicação de produtos a partir de promoções, destaques e histórico de compras do cliente.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark checkmark-green"> </div>
                        <p><b>Gestão comercial</b>: indicadores e relatórios personalizáveis em tempo real para uma gestão mais inteligente.</p>
                    </div>
                </div>
                <a className="new-button button-primary" href="/automacao-vendas/">saiba mais</a>

                <div className="apps-wrapper">
                    <a className="button-store" href="https://play.google.com/store/apps/details?id=br.com.meuspedidos&amp;hl=pt_BR" target="_blank" rel="noreferrer noopener">
                        <Picture
                            className='apps-image'
                            src="/images/site/content/google-play.png"
                            alt='Google Play'
                        />
                    </a>
                    <a className="button-store" href="https://apps.apple.com/br/app/meus-pedidos/id485511628" target="_blank" rel="noreferrer noopener">
                        <Picture
                            className='apps-image'
                            src="/images/site/content/apple-store.png"
                            alt='Apple Store'
                        />
                    </a>
                </div>
            </div>

        </div>
    )
}




// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/SalesAutomation.jsx